export default "__VITE_ASSET__DpX2GphA__"